export const intervalTypes = {
    60: { timeStep: { hours: 1 }, dividerValue: 4 },
    15: { timeStep: { minutes: 15 }, dividerValue: 1 },
};
